import React from "react";
import ProjectSquare from "./MobileProjectSquare";
import images from "../../data/projectImages.js"

const MobileProgress = () => {
  return (
    <div className="flex flex-col justify-center items-center p-8 pt-0">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 place-items-center justify-center gap-y-6 w-full p-2">
        <ProjectSquare
          imageUrl={images["121Broadway"][0]}
          name="121 Broadway"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["Binney"][0]}
          name="290/250 Binney Street"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["MassGeneral"][0]}
          name="Mass General Hospital"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["HarvardERC"][0]}
          name="Harvard ERC East & West Labs"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["PCNursingSchool"][0]}
          name="Providence College School of Nursing"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["WomenInfants"][0]}
          name="Women & Infants Hospital"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["BrownDanoffLab"][0]}
          name="Brown University Danoff Laboratory"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["VolpeC3"][0]}
          name="Volpe C3"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["GreatWolf"][0]}
          name="Great Wolf Resorts"
          loc="Ledyard, CT"
        />
        <ProjectSquare
          imageUrl={images["UMassInpatient"][0]}
          name="UMass New Inpatient Tower"
          loc="Worcester, MA"
        />
        <ProjectSquare
          imageUrl={images["YaleGradHousing"][0]}
          name="Yale University Graduate Housing"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["BrownITF"][0]}
          name="Brown University Indoor Turf Facility"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["YaleWrightLab"][0]}
          name="Yale University Wright Lab Building"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["YaleNewHavenNeuro"][0]}
          name="Yale New Haven Hospital Neuroscience Bed Tower"
          loc="New Haven, CT"
        />
      </div>
    </div>
  );
};

export default MobileProgress;
